// removed by extract-text-webpack-plugin
module.exports = {"Post":"zxhDhvegyDoIoTfW9wKt2","Date":"_2DUUeTrxvIqBX_eo8fBGMl","Rating":"_10zhysSUMzhYUrbV7B4Rf6","FeedbackText":"LdOwZGpDniSrgnKnWy9kI"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/RightPanel/PostHistory/Post/style.css
// module id = 2463
// module chunks = 0